import Balance from 'src/assets/icons/sidebar/balance.svg'
import BalanceDark from 'src/assets/icons/sidebar/balance_dark.svg'
import Base from 'src/assets/icons/sidebar/base.svg'
import BaseDark from 'src/assets/icons/sidebar/base_dark.svg'
import Guard from 'src/assets/icons/sidebar/guard.svg'
import GuardDark from 'src/assets/icons/sidebar/guard_dark.svg'
import Others from 'src/assets/icons/sidebar/others.svg'
import OthersDark from 'src/assets/icons/sidebar/others_dark.svg'
import Quant from 'src/assets/icons/sidebar/quant.svg'
import QuantDark from 'src/assets/icons/sidebar/quant_dark.svg'
import ReEngage from 'src/assets/icons/sidebar/re_engage.svg'
import ReEngageDark from 'src/assets/icons/sidebar/re_engage_dark.svg'
import Recover from 'src/assets/icons/sidebar/recover.svg'
import RecoverDark from 'src/assets/icons/sidebar/recover_dark.svg'
import SystemConfiguration from 'src/assets/icons/sidebar/system_configuration.svg'
import SystemConfigurationDark from 'src/assets/icons/sidebar/system_configuration_dark.svg'
import TruROI from 'src/assets/icons/sidebar/truroi.svg'
import TruROIDark from 'src/assets/icons/sidebar/truroi_dark.svg'
import Wizard from 'src/assets/icons/sidebar/wizard.svg'
import WizardDark from 'src/assets/icons/sidebar/wizard_dark.svg'
import BalanceColoredIcon from 'src/components/Icon/categories/BalanceColoredIcon'
import GuardColoredIcon from 'src/components/Icon/categories/GuardColoredIcon'
import RecoverColoredIcon from 'src/components/Icon/categories/RecoverColoredIcon'
import ReEngageColoredIcon from 'src/components/Icon/categories/ReEngageColoredIcon'
import TruROIColoredIcon from 'src/components/Icon/categories/TruROIColoredIcon'

export const CategoryIconMapping = {
  wizard: Wizard,
  base_routes: Base,
  recover: Recover,
  guard: Guard,
  balance: Balance,
  truroi: TruROI,
  re_engage: ReEngage,
  quant: Quant,
  system_configuration: SystemConfiguration,
  others: Others
}

export const CategoryIconMappingDark = {
  wizard: WizardDark,
  base_routes: BaseDark,
  recover: RecoverDark,
  guard: GuardDark,
  balance: BalanceDark,
  truroi: TruROIDark,
  re_engage: ReEngageDark,
  quant: QuantDark,
  system_configuration: SystemConfigurationDark,
  others: OthersDark
}

export const CategoryIconMappingColored = {
  recover: RecoverColoredIcon,
  guard: GuardColoredIcon,
  balance: BalanceColoredIcon,
  truroi: TruROIColoredIcon,
  re_engage: ReEngageColoredIcon
}
